import { ReactComponent as FreebiesIcon } from "../../images/global/gift-line.svg";

const Freebies = ({ freebies, styles }) => {
  return (freebies.length > 0) && (
    <div className={styles.cartItem} id="freebies-info">
      <div className={styles.cro1381HotelHeading}>
        <FreebiesIcon />
        <h3 className={styles.freebiesHeader}>FREE Gifts</h3>
      </div>
      <ul
        className={`${styles.cro1381HotelMeta} ${styles.cro1381HotelFreebies}`}
        data-testId="freebie-titles"
      >
        {freebies.map((freebie, index) => {
          return (
            <li className={styles.freebie} key={index}>
              {freebie.title}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Freebies;
